module.exports = __webpack_public_path__ + "static/media/animation-e2-icon.2a18c9d0.png";